module.exports = __webpack_public_path__ + "fonts/fa-light-300.5f6edb4.ttf";